import { initializeApp } from "firebase/app";
import {getAuth, GoogleAuthProvider} from "firebase/auth";

import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
    apiKey: "AIzaSyDddOBU5SWs8cJHUosv_fm2a0zLpz77LEo",
    authDomain: "ldrproject-4b256.firebaseapp.com",
    projectId: "ldrproject-4b256",
    storageBucket: "ldrproject-4b256.firebasestorage.app",
    messagingSenderId: "34398039646",
    appId: "1:34398039646:web:2e16b5bda2b0b9d50e4ecf",
    measurementId: "G-YKZ43Y7Q7E"
};


export const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const googleProvider = new GoogleAuthProvider();

export const db = getFirestore(app);